// Third Party Imports
import React from 'react';
import {ButtonLink} from '@homeaway/react-buttons';

// Relative Imports
import './SubHead.less';
import SaveAndFinishModal from './SaveAndFinishModal';


export default class SubHead extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {
            translations,
            handleSaveAndFinishOnClick,
            isSaveModalOpen,
            handleSaveModalClose
        } = this.props;

        return (
            <div id="subHead" className="sub-head">
                <SaveAndFinishModal
                    translations={translations}
                    isSaveModalOpen={isSaveModalOpen}
                    handleSaveModalClose={handleSaveModalClose}
                />
                <div className="wrapper-sub-head">
                    <div className="content-col-sub-head">
                        <ButtonLink
                            type="button"
                            id={'saveButton'}
                            className="save-btn"
                            size="sm"
                            label={translations['ipmob.sub_head.button_text_1']}
                            onClick={handleSaveAndFinishOnClick}
                            href="#"
                        />
                    </div>
                </div>
                <div className="wrapper-sub-head">
                    <div className="sub-head-divider"/>
                </div>
            </div>
        );
    }
}
